export class CompanyLinked {
  constructor(
    public id: number = null,
    public name: string = "",
    public companyId: string = "",
    public address: string = "",
    public address2: string = "",
    public colonia: string = "",
    public city: string = "",
    public zipCode: string = "",
    public country: string = "",
    public phone: string = "",
    public mobilePhone: string = "",
    public activo: number = null,
    public unedaEnabled: number = null,
    public unedaType: string = "",
    public unedaIqKey: string = "",
    public termsId: any = null,
    public conditionId: any = null,
    public currenciesId: any = null,
    public soDigits: number = null,
    public soLineDigits: number = null,
    public poDigits: number = null,
    public poLineDigits: number = null,
    public ppDigits: number = null,
    public ppLineDigits: number = null,
    public contact: string = "",
    public website: string = "",
    public url: string = "",
    public email: string = "",
    public soBeginningId: number = null,
    public poBeginningId: number = null,
    public ppBeginningId: number = null,
    public holidaysLeads: boolean = false,
    public typeHolidaysLeads: string = "", // Rep ó Random
    public assignHolidaysLeads: any = null,
    public weightUnit: string = "",
    public imgFile: string = "",
    public quickbooksToken: string = "",
    public taxExempt: number = 0,
    public salesTaxNumber: string = "",
    public taxNumber: string = "",
    public pdfSlogan: string = "",
    public fax: string = "",
    public alias: string = "",
    public purchasingtermsId: any = null,
    public passDataErasure1: string = null,
    public enablePartyPickup: number = 0,
    public creditLimit = "",
    public purchasingCreditLimit = "",
    public outstandingInvoiceDayLimit = "",
    public industryType = null,
    public certificationExpirationDate: { timestamp: number } = {
      timestamp: 0,
    },
    public certificationinitialdate: { timestamp: number } = { timestamp: 0 },
    public certificationactive: number = 0,
    public vipStatus: any = 0
  ) {}
}
